export const GET_NEXT_SYMPTOM_SUCCESS = 'GET_NEXT_SYMPTOM_SUCCESS'
export const GET_NEXT_SYMPTOM_FAIL = 'GET_NEXT_SYMPTOM_FAIL'
export const GET_NEXT_SYMPTOM_CLEAR_DATA = 'GET_NEXT_SYMPTOM_CLEAR_DATA'
